import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class DeleteLocationConfirmation extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
  }
  render() {
    const { open, onClose, onConfirm } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={onClose}
      />,
      <FlatButton
        label="Delete"
        primary={true}
        onTouchTap={onConfirm}
      />,
    ];

    return (
      <Dialog
          actions={actions}
          modal={false}
          open={open}
          onRequestClose={onClose}
        >
          Are you sure you want to delete this location?
        </Dialog>
    );
  }
}

export default DeleteLocationConfirmation;


// WEBPACK FOOTER //
// ./src/containers/Modals/DeleteLocationConfirmation.js